// removed by extract-text-webpack-plugin
module.exports = {"vpEnableCameraButton":"vpEnableCameraButton___cZkE-","vpInputDisabled":"vpInputDisabled___2UMxI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/VideoRecorderEnableButton.module.less
// module id = 2563
// module chunks = 29